import { useState } from 'react';
import Accordion from '../resuable-components/Accordion';

const FAQSection = () => {
  const faqs = [
    {
      question: "How do I open an EximPe Global Collection Account?",
      answer: (
        <>
          Visit{" "}
          <a
            href="https://app.eximpe.com/auth/sign-up "
            className="underline font-bold italic"
            target="_blank"
            rel="noopener noreferrer"
          >
            our sign-up page
          </a>{" "}
          to create an account. Complete KYC verification to activate your account within 48 hours.
        </>
      ),
    },
    {
      question: "What currencies are supported?",
      answer: "We support 30+ currencies including USD, EUR, GBP, and more across 100+ countries.",
    },
    {
      question: "What are the charges?",
      answer: (
        <>
          <p>Platform fee: 0.75%</p>
          <p>Local collection fee: 0.59 in transaction currency</p>
          <p>SWIFT transfers: $7.67 per transaction</p>
        </>
      ),
    },
    {
      question: "Can I keep funds in my global account?",
      answer: "No, funds are automatically converted to INR and transferred to your Indian account daily.",
    },
    {
      question: "How do I receive money?",
      answer: "Share your global account details with clients. Funds will be converted and credited to your Indian account within 24-48 hours with e-FIRA.",
    },
    {
      question: "Is this RBI-compliant?",
      answer: "Yes, we partner with RBI-licensed banks and provide e-FIRA for all transactions.",
    },
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <section className="py-16 text-[#1A202C] mlg:px-[10%] mt-[10px] bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-[#1A202C] mb-12">
          FAQs
        </h2>
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <Accordion
              key={index}
              title={faq.question}
              content={faq.answer}
              isOpen={activeIndex === index}
              onToggle={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;